import React, { useMemo, useState } from 'react'
import fastDeepEqual from 'fast-deep-equal'
import { getLocationFromAddress, ILocation } from './locationHelpers'
import IconField from '../../inputIcon'
import { CustomInputMappingField } from '@tuqqi/common'
import { makeStyles, Theme } from '@material-ui/core'
import { LocationMap } from './LocationMap'
import { LocationTextEdit } from './LocationTextEdit'

const styles = (theme: Theme) => ({
    container: {
        padding: 24,
        paddingLeft: 0,
        paddingRight: 0,
        width: 'inherit',
        marginTop: -10,
        // marginLeft: 10,
        paddingTop: 0,
    },
    map: {
        transition: 'opacity 0.25s ease-in-out', 
        marginLeft: 54, 
        marginRight: 8, 
    }
})

const useStyles = makeStyles(styles)


type Props = {
    isRtl: boolean
    location: ILocation | null
    setLocation: (l: ILocation | null) => void
}

export const InputLocation = (props: Props) => {
    const geoLocation = props.location?.geoLocation ?? undefined
    const locationAddress = props.location?.locationAddress ?? undefined
    const classes = useStyles()
    const label = "Address"

    const value: ILocation | null = useMemo(() => {
        if(!locationAddress || !geoLocation) return null
        return {
            geoLocation,
            locationAddress
        }
    }, [locationAddress, geoLocation])

    const [shown, setShown] = useState(!!value)

    const show = () => {
        setShown(true)
    }

    const updateLocation = (location: ILocation | null) => {
        const hasValueChanged = !fastDeepEqual(location, value)
        if(!hasValueChanged) return

        props.setLocation(location)
    }
    const updateLocationFromAddress = async (locationAdress?: string) => {
        const correctAddress = await getLocationFromAddress(locationAdress ?? '')
        const hasValueChanged = !fastDeepEqual(correctAddress, value)
        if(!hasValueChanged) return

        props.setLocation(correctAddress)
    }
    
    const icon = <IconField field={{type: 'location'} as CustomInputMappingField} />

    const renderMap = () => {
        if(!shown) return null
        return <div data-intrcm-id="InputLocation_3umz46lh" className={classes.map} >
                <LocationMap isReadOnly={false} updateCurrentLocation={updateLocation} value={value} />
        </div>
    }

    return <div data-intrcm-id="InputLocation_nidcuhmg" className={classes.container}>
        <LocationTextEdit isRtl={props.isRtl} setShown={setShown} shown={shown} isNewItem sourceField='' icon={icon} value={value} label={label} description={""} onBlur={updateLocationFromAddress} />
        {renderMap()}
    </div>

}